const config = {
    "broker": "1",
    "name": "Arabic",
    "registrationBundle": "english",
    "defaultCountryName": "Saudi Arabia",
    "defaultCountryCode": "SA",
    "fxgeoip_code": "AR",
    languageCode: 'en',
    languageName:'English',
    spokenLanguageCode:'en',
    direction:'ltr',
    footerDisclaimer:'699',
    brand: 'iforex'
};
module.exports = config;